import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

type RuntimeEnv = Record<string, string | boolean | number | undefined>;

// ------------------------------------------------------ Validações comuns para variáveis de ambiente
const stringObrigatoria = z.string({ required_error: "obrigatória" }).trim().min(1, "obrigatória");

const urlObrigatoria = z.string({ required_error: "obrigatória" }).trim().url("deve ser uma URL válida");

const urlHttpsObrigatoria = urlObrigatoria.refine((valor) => valor.toLowerCase().startsWith("https://"), {
	message: "deve usar protocolo HTTPS",
});

const urlOpcional = z.string().trim().url("deve ser uma URL válida").optional();

const booleanOpcional = z
	.enum(["true", "false"], {
		errorMap: () => ({ message: "deve ser true ou false" }),
	})
	.optional()
	.default("false")
	.transform((valor) => valor === "true");

// ------------------------------------------------------ Factory utilizada pela aplicação
export function criarEnv(runtimeEnv: RuntimeEnv) {
	return createEnv({
		clientPrefix: "VITE_",
		client: {
			VITE_API_BASE_URL_AUTHENTICATOR: urlObrigatoria,
			VITE_API_BASE_URL_COMPRA_INTELIGENTE: urlObrigatoria,
			VITE_API_BASE_URL_REPORT: urlObrigatoria,
			VITE_API_BASE_URL_PESSOAS_SERVICE: urlObrigatoria,
			VITE_API_BASE_URL_ESTOQUE_SERVICE: urlObrigatoria,
			VITE_API_BASE_URL_UTILITARIOS_SERVICE: urlObrigatoria,
			VITE_API_BASE_URL_COMPRA_SERVICE: urlObrigatoria,
			VITE_API_POWERBI_TOKEN: urlObrigatoria,
			VITE_API_POWERBI: urlHttpsObrigatoria,
			VITE_SPACE_USERNAME: stringObrigatoria,
			VITE_SOCKET_IO_URL: urlOpcional,
			VITE_USERTOUR_TOKEN: z.string().trim().optional(),
			VITE_ENABLE_MOCKS: booleanOpcional,
			VITE_TURNSTILE_KEY: stringObrigatoria,
			VITE_API_BASE_URL_CONTAS_A_PAGAR_SERVICE: urlObrigatoria,
			VITE_API_BASE_URL_DASHBOARD_SERVICE: urlObrigatoria,
			VITE_API_BASE_URL_PLUG_SIGN: urlObrigatoria,
			VITE_API_BASE_URL_IA: urlObrigatoria,
			VITE_API_BASE_URL_EMISSAO_FISCAL_SERVICE: urlObrigatoria,
			VITE_API_BASE_URL_COMUNICATION: urlObrigatoria,
			VITE_API_BASE_URL_DFE: urlObrigatoria,
		},
		runtimeEnv: { ...runtimeEnv },
		emptyStringAsUndefined: true,
		onValidationError: (issues) => {
			const detalhes = issues.map((issue) => {
				const campo =
					issue.path
						?.map((segmento) => (typeof segmento === "object" ? String(segmento.key) : String(segmento)))
						.join(".") || "env";

				return `- ${campo}: ${issue.message}`;
			});

			throw new Error(["Variáveis de ambiente inválidas:", ...detalhes].join("\n"));
		},
	});
}
